var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckselect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 11,
    fill: "#454787"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "#454787",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3667 13.7795L15.8472 8.2992C16.0244 8.12187 16.2333 8.0332 16.4739 8.0332C16.7145 8.0332 16.9235 8.12187 17.1007 8.2992C17.278 8.47643 17.3667 8.68654 17.3667 8.92954C17.3667 9.17254 17.278 9.3827 17.1007 9.56004L10.9935 15.6745C10.8162 15.8519 10.6072 15.9405 10.3667 15.9405C10.1261 15.9405 9.91719 15.8519 9.73986 15.6745L6.89202 12.8267C6.71469 12.6494 6.62724 12.4392 6.62969 12.1962C6.63213 11.9532 6.72202 11.7431 6.89936 11.5659C7.07658 11.3885 7.28669 11.2999 7.52969 11.2999C7.77269 11.2999 7.98286 11.3885 8.16019 11.5659L10.3667 13.7795Z",
    fill: "#50E299"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckselect);
export default __webpack_public_path__ + "static/media/checkselect.c96f7cf80e29041ed1ba0240be68f078.svg";
export { ForwardRef as ReactComponent };